import React, { useEffect, useState } from "react";
import { MensajeAPI } from "../../api/api"; // importa tu API de mensajes
import "bootstrap/dist/css/bootstrap.min.css";

export default function ManageMessages() {
  const [mensajes, setMensajes] = useState([]);
  const [loading, setLoading] = useState(true);

  // Obtener todos los mensajes
  const fetchMensajes = async () => {
    try {
      const data = await MensajeAPI.getAll();
      setMensajes(data);
    } catch (err) {
      console.error("Error al obtener mensajes:", err);
      alert("No se pudieron cargar los mensajes.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMensajes();
  }, []);

  // Eliminar un mensaje
  const handleDelete = async (id) => {
    if (!window.confirm("¿Seguro que quieres eliminar este mensaje?")) return;
    try {
      await MensajeAPI.delete(id);
      setMensajes((prev) => prev.filter((msg) => msg.id !== id));
    } catch (err) {
      console.error("Error al eliminar mensaje:", err);
      alert("No se pudo eliminar el mensaje.");
    }
  };

  if (loading) return <p className="text-center mt-5">Cargando mensajes...</p>;

  return (
    <div className="container py-5 mt-5">
      <h2 className="mb-4 text-success">Mensajes recibidos</h2>

      {mensajes.length === 0 && (
        <p className="text-center text-muted">No hay mensajes registrados.</p>
      )}

      <div className="row row-cols-1 row-cols-md-2 g-4">
        {mensajes.map((msg) => (
          <div className="col" key={msg.id}>
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <p><strong>De:</strong> {msg.nombreCompleto} &lt;{msg.correo}&gt;</p>
                <p><strong>Mensaje:</strong> {msg.mensaje}</p>
              </div>
              <div className="card-footer text-end">
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(msg.id)}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
